import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type CreateManagedAccountMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.CreateManagedAccountInput;
}>;

export type CreateManagedAccountMutationResult = { __typename?: 'Mutation' } & {
  createManagedAccount?: GraphQLTypes.Maybe<
    { __typename?: 'CreateManagedAccountPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const CreateManagedAccountDocument = gql`
  mutation createManagedAccount($input: CreateManagedAccountInput!) {
    createManagedAccount(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
